module.exports = __webpack_public_path__ + "static/whatsappStore-icon-menu-1bbf6caba89bf0bdcbea9321ef3bfb71.svg";